"use strict";

// Header scroll
(() => {
  const header = document.querySelector("header.header");
  if (!header) return;

  const SHOW_AT = 300; // після цього px можемо показувати
  const HIDE_BELOW = 280; // нижче цього px точно ховаємо (гістерезис)
  const DELTA = 4; // ігноруємо мікрорухи 1–3px

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  const setScrolled = (on) => {
    if (header.classList.contains("header-scroll") === on) return;
    header.classList.add("header-no-transition");
    header.classList.toggle("header-scroll", on);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        header.classList.remove("header-no-transition");
      });
    });
  };

  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const diff = scrollTop - lastScrollTop;

    // 1) Завжди ховаємо, якщо реально близько до верху сторінки
    if (scrollTop < HIDE_BELOW) {
      setScrolled(false);
      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    // 2) Після SHOW_AT працюємо по напряму скролу, але лише якщо рух суттєвий
    if (scrollTop >= SHOW_AT && Math.abs(diff) >= DELTA) {
      if (diff > 0) {
        setScrolled(true); // скрол вниз
      } else {
        setScrolled(false); // скрол вгору
      }
    }

    lastScrollTop = scrollTop;
    ticking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true },
  );
})();

// Progressbar Scroll
(() => {
  if (window.innerWidth >= 1024) return;
  if (typeof siteSettings !== "undefined" && siteSettings.isFrontPage) return;

  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header.header");
    if (!header) return;

    const progressBarContainer = document.createElement("div");
    progressBarContainer.id = "progress-container";
    progressBarContainer.style.display = "none";

    const progressBar = document.createElement("div");
    progressBar.id = "progress-bar";

    progressBarContainer.appendChild(progressBar);
    header.appendChild(progressBarContainer);

    const updateProgress = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      // показ / приховування
      progressBarContainer.style.display = scrollTop > 0 ? "block" : "none";

      if (docHeight <= 0) return;

      const progress = (scrollTop / docHeight) * 100;
      progressBar.style.width = progress + "%";
    };

    window.addEventListener("scroll", updateProgress, { passive: true });
  });
})();

// Animate Scroll
(() => {
  const header = document.querySelector("header");
  const getHeaderHeight = () => (header ? header.offsetHeight : 0);

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute("href");
    if (!id || id === "#") return;

    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();

    const targetTop =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getHeaderHeight();

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });
  });
})();

// Mobile Nav Toggle
(() => {
  const body = document.body;
  const burger = document.querySelector("button.burger");
  const nav = document.querySelector(".header-nav");

  if (!burger || !nav) return;

  const closeNav = () => {
    body.classList.remove("overflow-hidden");
    nav.classList.remove("active");
    burger.classList.remove("burger-active");
    nav
      .querySelectorAll(".menu-item-has-children.open")
      .forEach((item) => item.classList.remove("open"));
  };

  burger.addEventListener("click", () => {
    if (nav.classList.contains("active")) {
      closeNav();
      return;
    }
    body.classList.add("overflow-hidden");
    nav.classList.add("active");
    burger.classList.add("burger-active");
  });

  const closeBtn = document.querySelector(".header-nav-close");
  if (closeBtn) {
    closeBtn.addEventListener("click", closeNav);
  }
})();

// Mobile SubNav open
(() => {
  const items = document.querySelectorAll(
    ".header-main-menu .menu > .menu-item-has-children",
  );
  if (!items.length) return;

  const isMobile = () => window.matchMedia("(max-width: 1024px)").matches;

  items.forEach((item) => {
    const link = item.querySelector(":scope > a");
    if (!link) return;

    link.addEventListener("click", (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      item.classList.toggle("open");
    });
  });
})();

// Social Share
(() => {
  const socialSpans = document.querySelectorAll(".social-share span");

  if (!socialSpans.length) return;

  socialSpans.forEach((span) => {
    span.addEventListener("click", () => {
      const link = span.dataset.link;
      const url = span.dataset.url;

      if (!link || !url) return;

      const fullUrl = "https://" + link + url;
      window.open(fullUrl, "_blank");
    });
  });
})();

// Corner crosses
(() => {
  const targets = document.querySelectorAll(".js-cross");
  if (!targets.length) return;

  targets.forEach((el) => {
    ["tl", "tr", "bl", "br"].forEach((pos) => {
      const cross = document.createElement("span");
      cross.className = "cross cross-" + pos;
      el.appendChild(cross);
    });
  });
})();

(() => {
  const faqList = document.querySelector(".faq-list");
  if (!faqList) return;

  const items = faqList.querySelectorAll(".faq-item");
  items.forEach((item) => {
    const answer = item.querySelector(".faq-answer");
    if (!answer) return;
    answer.style.height = "0px";
    answer.style.overflow = "hidden";
  });

  window.addEventListener("load", () => {
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => {
      items.forEach((item, index) => {
        const answer = item.querySelector(".faq-answer");
        if (!answer) return;

        item.addEventListener("click", (e) => {
          if (e.target.closest("a, button, input, textarea, select")) return;

          const isActive = item.classList.contains("active");

          items.forEach((otherItem) => {
            if (otherItem === item) return;
            otherItem.classList.remove("active");
            const otherAnswer = otherItem.querySelector(".faq-answer");
            if (otherAnswer) otherAnswer.style.height = "0px";
          });

          item.classList.toggle("active", !isActive);
          answer.style.height = !isActive
            ? answer.scrollHeight + "px"
            : "0px";
        });
      });

      const secondItem = items[1];
      if (secondItem) {
        const answer = secondItem.querySelector(".faq-answer");
        secondItem.classList.add("active");
        if (answer) answer.style.height = answer.scrollHeight + "px";
      }

      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          items.forEach((item) => {
            const answer = item.querySelector(".faq-answer");
            if (!answer) return;
            answer.style.height = "auto";
            answer.dataset.height = answer.scrollHeight;
            answer.style.height = item.classList.contains("active")
              ? answer.dataset.height + "px"
              : "0px";
          });
        }, 150);
      });
    });
  });
})();

(() => {
  var header = document.querySelector("header.header");
  if (!header) return;
  var ADD_AT = 5;
  var REMOVE_AT = 4;
  var ticking = false;
  var setScrolled = function setScrolled(on) {
    if (header.classList.contains("header-scroll") === on) return;
    header.classList.add("header-no-transition");
    header.classList.toggle("header-scroll", on);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        header.classList.remove("header-no-transition");
      });
    });
  };
  var onScroll = function onScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= ADD_AT) {
      setScrolled(true);
    } else if (scrollTop <= REMOVE_AT) {
      setScrolled(false);
    }
    ticking = false;
  };
  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    {
      passive: true,
    },
  );
  requestAnimationFrame(onScroll);
})();

(() => {
  const init = () => {
    if (typeof Swiper === "undefined") return;
    const sliders = document.querySelectorAll(".js-mobile-slider");
    if (!sliders.length) return;

    const mq = window.matchMedia("(max-width: 1024px)");
    const instances = new Map();

    const apply = () => {
      sliders.forEach((el) => {
        if (mq.matches && !instances.has(el)) {
          instances.set(
            el,
            new Swiper(el, {
              slidesPerView: "auto",
              spaceBetween: Number(el.dataset.space || 0),
              watchOverflow: false,
              observer: true,
              observeParents: true,
              pagination: {
                el: el.querySelector(".swiper-pagination"),
                clickable: true,
              },
            }),
          );
        } else if (!mq.matches && instances.has(el)) {
          instances.get(el).destroy(true, true);
          instances.delete(el);
        }
      });
    };

    apply();
    mq.addEventListener("change", apply);
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
})();

(() => {
  const init = () => {
    const wraps = document.querySelectorAll(".wpcf7-form-control-wrap");
    if (!wraps.length) return;

    wraps.forEach((wrap) => {
      const control = wrap.querySelector(".wpcf7-form-control");
      if (!control) return;

      const isRequired =
        control.classList.contains("wpcf7-validates-as-required") ||
        control.required ||
        control.getAttribute("aria-required") === "true";

      if (!isRequired) return;

      wrap.classList.add("is-required");

      const sync = () => {
        const isSelect = control.tagName === "SELECT";
        const filled = isSelect
          ? control.value !== ""
          : control.value.trim() !== "";
        wrap.classList.toggle("is-filled", filled);
      };

      control.addEventListener("input", sync);
      control.addEventListener("change", sync);
      control.addEventListener("blur", sync);

      sync();
    });
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }
})();


(() => {
  const popupWrap = document.querySelector(".popup-wrap");
  if (!popupWrap) return;

  const openPopup = () => {
    popupWrap.style.display = "flex";
  };
  const closePopup = () => {
    popupWrap.style.display = "none";
  };

  document.addEventListener("click", (e) => {
    if (e.target.closest('.show-popup-form, a[href*="#popup"]')) {
      e.preventDefault();
      openPopup();
    }
    if (e.target.closest(".close-popup")) {
      closePopup();
    }
    if (e.target === popupWrap) {
      closePopup();
    }
  });

  if (window.location.hash === "#popup") {
    openPopup();
  }
})();
(() => {
  const clampExcerpts = () => {
    document.querySelectorAll(".blog-post-info").forEach((info) => {
      const excerpt = info.querySelector(".blog-post-excerpt");
      if (!excerpt) return;

      excerpt.style.display = "-webkit-box";
      excerpt.style.webkitBoxOrient = "vertical";
      excerpt.style.overflow = "hidden";
      excerpt.style.webkitLineClamp = "";

      const styles = getComputedStyle(excerpt);
      let lineHeight = parseFloat(styles.lineHeight);
      if (!lineHeight || Number.isNaN(lineHeight)) {
        lineHeight = parseFloat(styles.fontSize) * 1.4;
      }

      const available =
        info.getBoundingClientRect().bottom -
        excerpt.getBoundingClientRect().top;
      const lines = Math.max(1, Math.floor(available / lineHeight));
      excerpt.style.webkitLineClamp = String(lines);
    });
  };

  const init = () => {
    clampExcerpts();
    if (document.fonts) {
      document.fonts.ready.then(clampExcerpts);
    }
  };

  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener("load", init, { once: true });
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(clampExcerpts, 150);
  });
})();

(() => {
  const links = document.querySelectorAll(
    "main.content a[data-lightbox], main.content a.prettyphoto",
  );
  if (!links.length) return;

  const overlay = document.createElement("div");
  overlay.className = "content-lightbox";
  overlay.innerHTML =
    '<button class="content-lightbox-close" type="button" aria-label="Close">&times;</button><img class="content-lightbox-img" src="" alt="">';
  document.body.appendChild(overlay);

  const img = overlay.querySelector(".content-lightbox-img");

  const close = () => {
    overlay.classList.remove("is-open");
    img.src = "";
    document.body.classList.remove("overflow-hidden");
  };

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const thumb = link.querySelector("img");
      img.src = link.href;
      img.alt = thumb ? thumb.alt : "";
      overlay.classList.add("is-open");
      document.body.classList.add("overflow-hidden");
    });
  });

  overlay.addEventListener("click", (e) => {
    if (e.target !== img) close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) close();
  });
})();

(() => {
  const labels = document.querySelectorAll(".about-us-stat-label");
  if (!labels.length) return;

  const animate = (el) => {
    const host = el.querySelector(".about-us-stat-label-number") || el;
    const text = host.textContent.trim();
    const match = text.match(/^([^\d]*)(\d+)([^\d]*)$/);
    if (!match) return;

    const prefix = match[1];
    const target = parseInt(match[2], 10);
    const suffix = match[3];
    const duration = 1500;
    let start = null;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      host.textContent = prefix + Math.round(target * eased) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    };

    host.textContent = prefix + 0 + suffix;
    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animate(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.5 },
  );

  labels.forEach((label) => observer.observe(label));
})();
